module.exports = __webpack_public_path__ + "img/mag-vein.da039333.png";